<script>
    import {createEventDispatcher} from 'svelte';
    const dispatch = createEventDispatcher();
    const elementAction = (tag) => {
      dispatch('elementAction', {tag, app});
    }
    export let app;
    let appIconMap = 'fas fa-map fa-light';
    let appIconTemperature = 'fas fa-light fa-temperature-low';
    let appIcon;

    $: if(app.type === 'Map') { appIcon =  'fas fa-map fa-light'} else if (app.type === 'Smart Environments') { appIcon = 'fas fa-light fa-house' }
    
</script>

<div class="column is-one-third is-full-touch">
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        {app.title}
      </p>
      <button class="card-header-icon" aria-label="more options">
        <span class="icon has-text-grey-light">
          <i class={appIcon} aria-hidden="true"></i>
        </span>
      </button>
    </header>
    <div class="card-content">
      <div class="content">
        <p>{app.description}</p>
      </div>
    </div>
    <footer class="card-footer">
      {#if app.isAdmin}
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="card-footer-item is-narrow is-size-7" on:click={() => elementAction('settings')} on:keydown={() => {}}><span class="icon"><i class="fas fa-gear"></i></span></a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="card-footer-item is-narrow is-size-7" on:click={() => elementAction('members')} on:keydown={() => {}}><span class="icon"><i class="fas fa-user-group"></i></span></a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="card-footer-item is-narrow is-size-7" on:click={() => elementAction('logs')} on:keydown={() => {}}>Logs</a>
         <!-- svelte-ignore a11y-missing-attribute -->
         <a class="card-footer-item is-narrow is-size-7" on:click={() => elementAction('devices')} on:keydown={() => {}}>Devices</a>
      {/if}
      <!-- svelte-ignore a11y-missing-attribute -->
      <a class="card-footer-item is-size-7" on:click={() => elementAction('view')} on:keydown={() => {}}>View</a>
    </footer>
  </div>
</div>

<style>
  .card-content {
    min-height: 100px;
  }
  .card-header-icon {
      cursor: default;
  }

</style>